import { useMemo } from 'react';

import { useCfind4473CreationFocusedNav } from '@confluence/experiment-cfind-4473-creation-focused-nav/entry-points/useCfind4473CreationFocusedNav';

import type { MenuId } from './useMenuItems';

export type PlatformCustomization = {
	menuId: MenuId;
	visible: boolean;
};

export const usePlatformCustomizationsWithSimplifyNav = (
	platformCustomizations: Array<PlatformCustomization>,
) => {
	const { isSimplifiedNav } = useCfind4473CreationFocusedNav(true);
	const platformCustomizationsWithSimplifyNav = useMemo(() => {
		const hiddenForExperiment: typeof platformCustomizations = isSimplifiedNav
			? [
					{ menuId: 'recent', visible: false },
					{ menuId: 'starred', visible: false },
					{ menuId: 'companyHubShortcut', visible: false },
					{ menuId: 'teamsShortcut', visible: false },
					{ menuId: 'templates', visible: true },
				]
			: [];
		// IDs of menu items whose visibility has been customized by the user
		const customizedMenuIds = new Set(platformCustomizations.map((item) => item.menuId));
		const itemsToHide = hiddenForExperiment.filter((item) => !customizedMenuIds.has(item.menuId));
		// For users in simplify nav, hide items that the user has not explicitly chosen to show
		return [...platformCustomizations, ...itemsToHide];
	}, [platformCustomizations, isSimplifiedNav]);
	return { platformCustomizationsWithSimplifyNav };
};
